/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { observer } from 'mobx-react';

import { licenseStore, projectStore } from 'stores';
import { PlanLimitWarning } from 'components';
import { DEV_LICENSE_MAX_COLLABORATORS } from 'utils/constants';
import hasAccess, { actions } from 'utils/user-access';

import * as Styled from './CollaboratorsLimit.styled';

const CollaboratorsLimit = () => {
  const { project, collaborators } = projectStore;
  const { isDeveloperLicense } = licenseStore;

  if (
    hasAccess(project, actions.MODIFY_COLLABORATORS) &&
    isDeveloperLicense &&
    collaborators.length >= DEV_LICENSE_MAX_COLLABORATORS
  ) {
    return (
      <Styled.CollaboratorsLimitContainer>
        <PlanLimitWarning />
      </Styled.CollaboratorsLimitContainer>
    );
  } else {
    return null;
  }
};

export default observer(CollaboratorsLimit);
